import BatchSftpProcessApiUrls from 'src/apiUrls/BatchSftpProcessApiUrls'
import BatchSftpProcessFormProperties from './BatchSftpProcessFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'

const {
  form: { CngViewForm }
} = components

function BatchSftpProcessViewForm({
  showNotification,
  id,
  onFetchPreSuccess = () => {
    //do nothing
   }
}) {
  return (
    <CngViewForm
      fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
      showNotification={showNotification}
      bodySection={
        <BatchSftpProcessFormProperties.Fields
          disabled={true}
          showNotification={showNotification}
        />
      }
      formikProps={BatchSftpProcessFormProperties.formikProps}
      toClientDataFormat={BatchSftpProcessFormProperties.toClientDataFormat}
      toServerDataFormat={BatchSftpProcessFormProperties.toServerDataFormat}
      fetch={{
        id: id,
        url: BatchSftpProcessApiUrls.GET
      }}
    />
  )
}

export default BatchSftpProcessViewForm
